import {
  ShippingOption,
  ShippingEstimate,
} from '@adapters/bigcommerce/types/shipping';
import {
  getExtendedDeliveryTime,
  getEstimatedDeliveryDate,
} from '@utils/delivery';
import { transformShippingPrice } from '@utils/transformShippingPrice';
import { DEFAULT_DELIVERY_TIMES } from './constants';

const getDefaultDeliveryTime = (isBike: boolean): string => {
  return isBike ? DEFAULT_DELIVERY_TIMES.BIKE : DEFAULT_DELIVERY_TIMES.DEFAULT;
};

export const transformShippingOptions = (
  locale: string,
  isBike: boolean,
  shippingOption: ShippingOption
): ShippingEstimate => {
  const defaultDeliveryTime = getDefaultDeliveryTime(isBike);
  let deliveryTime = defaultDeliveryTime;
  let estimatedDeliveryDate = '';

  if (shippingOption?.shippingDays) {
    deliveryTime = getExtendedDeliveryTime(shippingOption.shippingDays);
    estimatedDeliveryDate = getEstimatedDeliveryDate(deliveryTime, locale);
  } else {
    // Default to 5-7 for regular shipping and 20-22 for bike shipping
    estimatedDeliveryDate = getEstimatedDeliveryDate(
      defaultDeliveryTime,
      locale
    );
  }

  const cost = transformShippingPrice(shippingOption?.cost ?? 0, locale);
  return {
    shippingOption: shippingOption,
    estimatedDeliveryDate: estimatedDeliveryDate,
    deliveryTime,
    isAvailable: true,
    cost,
  };
};

export const transformShippingOptionsArray = (
  shippingOptions: ShippingOption[],
  locale: string,
  isBike: boolean
): ShippingEstimate[] => {
  return shippingOptions.map((option) =>
    transformShippingOptions(locale, isBike, option)
  );
};
